import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { api, type Client } from "../lib/api";
import { navigate } from "../lib/route";

export function ClientsPage() {
  const { t } = useTranslation();
  const [clients, setClients] = useState<Client[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  async function load() {
    setLoading(true);
    setError(null);
    try {
      setClients(await api.listClients());
    } catch (err) {
      setError(err instanceof Error ? err.message : "Failed to load");
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    void load();
  }, []);

  async function handleDelete(id: string) {
    if (!confirm("Remove this client? Bookings/galleries keep working but lose the link.")) return;
    try {
      await api.deleteClient(id);
      await load();
    } catch (err) {
      setError(err instanceof Error ? err.message : "Delete failed");
    }
  }

  return (
    <div>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "1rem", flexWrap: "wrap", gap: "0.5rem" }}>
        <h1 style={{ margin: 0 }}>{t("clients.title")}</h1>
        <button className="btn-primary" onClick={() => navigate("/clients/new")}>
          {t("clients.new")}
        </button>
      </div>

      {error && <div className="alert alert-error">{error}</div>}
      {loading && <p style={{ color: "var(--muted)" }}>Loading…</p>}

      {!loading && clients.length === 0 && (
        <p style={{ color: "var(--muted)" }}>{t("clients.empty")}</p>
      )}

      <div style={{ display: "grid", gap: "0.75rem" }}>
        {clients.map((c) => (
          <div key={c.ID} className="card" style={{ cursor: "pointer" }} onClick={() => navigate(`/clients/${c.ID}`)}>
            <div style={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", gap: "1rem", flexWrap: "wrap" }}>
              <div style={{ flex: 1 }}>
                <strong style={{ fontSize: "1.05rem", color: "var(--primary)" }}>{c.DisplayName}</strong>
                <div style={{ marginTop: "0.25rem", color: "var(--muted)", fontSize: "0.875rem", display: "flex", gap: "1rem", flexWrap: "wrap" }}>
                  {c.Email && (
                    <span>
                      <a
                        href={`mailto:${c.Email}`}
                        onClick={(e) => e.stopPropagation()}
                        style={{ color: "inherit" }}
                      >
                        {c.Email}
                      </a>
                    </span>
                  )}
                  {c.Phone && <span>{c.Phone}</span>}
                </div>
                {c.Notes && (
                  <p style={{ marginTop: "0.4rem", color: "var(--muted)", fontSize: "0.875rem", margin: "0.4rem 0 0", overflow: "hidden", display: "-webkit-box", WebkitLineClamp: 2, WebkitBoxOrient: "vertical" }}>
                    {c.Notes}
                  </p>
                )}
              </div>
              <div style={{ display: "flex", gap: "0.5rem" }} onClick={(e) => e.stopPropagation()}>
                <button
                  className="btn-ghost"
                  style={{ padding: "0.4rem 0.75rem", fontSize: "0.875rem" }}
                  onClick={() => navigate(`/clients/${c.ID}`)}
                >
                  Bekijken
                </button>
                <button
                  onClick={() => handleDelete(c.ID)}
                  className="btn-ghost"
                  style={{ padding: "0.4rem 0.75rem", fontSize: "0.875rem", color: "#ef4444" }}
                >
                  Verwijderen
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
